module.exports = __webpack_public_path__ + "img/thanks.7c2296f.svg";